














import { Component, Vue, Prop } from 'vue-property-decorator';
import YandexShare from '@cookieseater/vue-yandex-share';

const DESCRIPTION =
  'Мы записались на программу через Центр опережающей профессиональной подготовки';
const TITLE = 'Центр опережающей профессиональной подготовки';
@Component({
  components: {
    YandexShare,
  },
})
export default class ComponentsPartsShare extends Vue {
  @Prop({ type: String, default: 'Поделиться: ' })
  text: string;

  @Prop({ type: Boolean, default: false })
  smallText: boolean;

  @Prop({ type: String, default: '' })
  initTitle: string;

  public title: string = this.initTitle || TITLE;

  public description: string = DESCRIPTION;

  public url: string = '';

  mounted() {
    this.url = window.location.href;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/share/Social.vue